import TermsConditionPage from "./termsConditionPage"

export default TermsConditionPage;